import axios from 'axios';

export function jwtInterceptor(token) {
  axios.interceptors.request.use(function (config) {
    // // config.headers.Authorization = `${token.token}`;
    config.headers.Authorization = `Bearer ${token.token}`;
    return config;
  });
}
